var exports = {
  "k": "x43aef4ae--eaa725--container",
};

module.exports = exports;
